const cartDefaultState = {
    cart_loaded: false,
    reorder_loading: false,
    loading: false,
    error: '',
    promoError: '',
    loyaltyError: '',
    locationError: '',
    name: '',
    phone: '',
    email: '',
    delivery_address: '',
    delivery_lat: 0.00,
    delivery_lng: 0.00,
    delivery_instructions: '',
    delivery_charge: 0.00,
    fuel_surcharge: 0.00,
    tip: 0.00,
    promo_code: '',
    promo_id: 0,
    promo_amount: 0.00,
    promo_delivery_amount: 0.00,
    order_type: '',
    pickup_time: '',
    subtotal: 0.00,
    taxes: 0.00,
    additional_charge: 0.00,
    total: 0.00,
    payment_method: 'online_payment',
    saved_card: 0,
    saved_card_name: '',
    savePayment: false,
    selectedReward: 0,  // the loyalty reward ID (had to use old API value)
    loyalty_redeem_amount: 0.00,
    stripeToken: '',
    completed_order_id: '',
    viewCCInfo: false,
    items: {
        pizzas: [],
        fooditems: [],
        beverages: [],
        specials: [],
        addons: []
    },
    loyalty_rewards: []
};

export default (state = cartDefaultState, action) => {

    switch(action.type) {

        case 'CART_SET_REORDER_LOADING':
            return {
                ...state,
                reorder_loading: action.reorder_loading
            }

        case 'CART_INFO_UPDATE':
            return {
                ...state,
                [action.field.prop]: action.field.value
            }


        case "CART_ADD_ITEM":
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.itemtype]: state.items[action.itemtype].concat(action.item)
                }
            }

        case "CART_REMOVE_ITEM":
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.itemtype]: state.items[action.itemtype].filter((theItem, theIndex) => {
                        return theIndex != action.itemindex;
                    })
                }
            }

        case "CART_RESET":
            return cartDefaultState;

        case "LOAD_CART":
            return {
                ...state,
                ...action.cart
            }

        default:
            return state;
    }
};